/**
 * Module dependencies.
 */

import { apiEndpoints } from 'src/core/api-endpoints';
import { authApiEndpoints } from 'src/core/auth-api-endpoints';

/**
 * `ApiEndpoint` type.
 */

type ApiEndpoint = keyof typeof apiEndpoints;

/**
 * `AuthApiEndpoint` type.
 */

type AuthApiEndpoint = keyof typeof authApiEndpoints;

/**
 * `Interpolations` type.
 */

type Interpolations = {
  [key: string]: string | number;
};

/**
 * Interpolates `:param` placeholders in a URL string.
 */

function interpolate(url: string, interpolations: Interpolations): string {
  return url.replace(/:([\s\S]+?)\b/g, (_, key) => String(interpolations[key] ?? ''));
}

/**
 * Export `getApiEndpoint`.
 */

export function getApiEndpoint(
  endpointName: ApiEndpoint,
  interpolations?: Interpolations
): string {
  const endpoint = apiEndpoints[endpointName];

  if (interpolations) {
    return interpolate(endpoint, interpolations);
  }

  return endpoint;
}

/**
 * Export `getAuthApiEndpoint`.
 */

export function getAuthApiEndpoint(
  endpointName: AuthApiEndpoint,
  interpolations?: Interpolations
): string {
  const endpoint = authApiEndpoints[endpointName];

  if (interpolations) {
    return interpolate(endpoint, interpolations);
  }

  return endpoint;
}
